import cx from 'classnames';
import dynamic from 'next/dynamic';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Skeleton from 'react-loading-skeleton';

import useWindowSize from '#app/hooks/useWindowSize';

import styles from './index.module.scss';

export const whyLearnList = [
  {
    title: 'Experiencias educativas prácticas y divertidas',
    description:
      'Experiencias lúdicas en vivo, con plataformas didácticas para aprender y divertirse.',
    image: '/why-learn-ctc/whyLearnCtc-1.png',
    icon: 'color-sky-blue'
  },
  {
    title: 'Alineación con las necesidades del mercado laboral actual',
    description:
      'Promovemos el intercambio cultural y el desarrollo de la imaginación entre alumnos de toda latinoamérica.',
    image: '/why-learn-ctc/whyLearnCtc-2.png',
    icon: 'color-orange'
  },
  {
    title: 'Desarrollo de habilidades del siglo XXI',
    description:
      'Habilidades de resolución de problemas, pensamiento lógico y autonomía para toda la vida.',
    image: '/why-learn-ctc/whyLearnCtc-3.png',
    icon: 'color-lila'
  }
];

const Typography = dynamic(() => import('#app/UI/atoms/typography-updated'));

const WhyLearn = () => {
  const { isDesktop } = useWindowSize();

  return (
    <section className={cx(styles.wrapper, 'mb-80 sm_mb-80 py-80')}>
      <div className={cx(styles.container, 'sm_px-40')}>
        <Typography className="sm_mb-56 mb-40 text-center" tag="h2">
          El futuro de nuestros jóvenes en tus manos{' '}
        </Typography>

        <ul
          className={cx(
            styles.list,
            'flex justify-between sm_flex-col sm_gap-y-64 mt-16'
          )}
        >
          {whyLearnList.map(({ title, image, icon }, idx) => (
            <li key={idx} className={cx(styles.item, 'flex flex-col items-center')}>
              <LazyLoadImage
                wrapperClassName="mb-24 sm_mb-20"
                effect="blur"
                alt="preview"
                width={isDesktop ? '320px' : '300ox'}
                height={isDesktop ? '240px' : '212px'}
                src={image}
                placeholder={<Skeleton width="100%" height="100%" />}
              />
              <LazyLoadImage
                wrapperClassName="mt-12 sm_mt-0"
                src={`/home/why-learn/${icon}.webp`}
                alt={`icon ${title}`}
                quality={80}
                priority
              />
              <div className={styles.containerText}>
                <Typography className="text-center" tag="h4">
                  {title}
                </Typography>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default WhyLearn;
